import { IoMdWarning } from 'react-icons/io'

type TWarningLabelProps = {
  readonly text: string
}

const WarningLabel = ({ text }: TWarningLabelProps) => {
  return (
    <div
      className={`flex flex-row items-center gap-1 rounded-2xl border border-pop-yellow-100 bg-pop-yellow-50 px-3 py-1 shadow-lg`}
    >
      <IoMdWarning className='text-pop-yellow-600' />
      <figure>
        <p className='text-xs text-pop-yellow-600'>{text}</p>
      </figure>
    </div>
  )
}

export default WarningLabel
